import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal} from 'react-bootstrap';
import CustomToast from '../../components/toast/toast.jsx';
import API from '../../api/api.jsx';

const Base_003_01 = ({ showModal,handleClose,SelectOptions1,SelectOptions2,SelectOptions3,SelectOptions4,DetailData }) => {
    const { t }                           = useTranslation();
    const [idCheckError, setIdCheckError] = useState(0);

     // 토스트
	const [toast, setToast]               = useState(false);
	const [text, setText]                 = useState('');

    // 수정여부 체크(값이 존재하는 경우는 true , 값이 null , undefinded, 빈문자열은 false )
    const isEditMode   = !!DetailData;
    const selectedData = DetailData;

    const InitUserSeq      = isEditMode ? selectedData.user_seq : '' ;     // 사용자SEQ
    const InitUser_id      = isEditMode ? selectedData.user_id : '' ;      // 사용자ID 
    const InitUser_name    = isEditMode ? selectedData.name : '' ;         // 사용자이름
    const InitPhone_number = isEditMode ? selectedData.phone_number : '';  // 핸드폰
    const InitTel_number   = isEditMode ? selectedData.tel_number : '' ;   // 핸드폰
    const InitEmail        = isEditMode ? selectedData.email : '' ;        // 이메일

    // 지점
    const initBranchCode = useMemo(() => (
        showModal ? (isEditMode ? selectedData.branch_code : SelectOptions1[0][0]) : []
    ), [showModal, isEditMode, selectedData, SelectOptions1]);
    
    // 권한
    const initAuthority = useMemo(() => (
        showModal ? (isEditMode ? selectedData.authority : SelectOptions2[0][0]) : []
    ), [showModal, isEditMode, selectedData, SelectOptions2]);
    
    // 사용자상태
    const initStatus = useMemo(() => (
        showModal ? (isEditMode ? selectedData.status : SelectOptions3[0][0]) : []
    ), [showModal, isEditMode, selectedData, SelectOptions3]);
    
    // 다국어
    const initLangCode = useMemo(() => (
        showModal ? (isEditMode ? selectedData.lang_code : SelectOptions4[0][0]) : []
    ), [showModal, isEditMode, selectedData, SelectOptions4]);

    const [formData, setFormData] = useState({
        user_seq      : '',
        user_id       : '',
        user_name     : '',
        phone_number  : '',
        tel_number    : '',
        email         : '',
        branch_code   : '',
        authority     : '',
        status        : '',
        lang_code     : '',
        temp_password : '',
    });

    // 렌더링
    useEffect(() => {
        // 모달이 활성화 된 경우
        if (showModal) {
            setIdCheckError(0);

            // 수정
            if (isEditMode) {
                setFormData({
                    user_seq      : selectedData.user_seq,
                    user_id       : selectedData.user_id,
                    user_name     : selectedData.name,
                    phone_number  : selectedData.phone_number,
                    tel_number    : selectedData.tel_number,
                    email         : selectedData.email,
                    branch_code   : selectedData.branch_code,
                    authority     : selectedData.authority,
                    status        : selectedData.status,
                    lang_code     : selectedData.lang_code,
                    temp_password : '',
                });
            } else {
                // 등록
                setFormData({
                    user_seq      : InitUserSeq,
                    user_id       : InitUser_id,
                    user_name     : InitUser_name,
                    phone_number  : InitPhone_number,
                    tel_number    : InitTel_number,
                    email         : InitEmail,
                    branch_code   : initBranchCode,
                    authority     : initAuthority,
                    status        : initStatus,
                    lang_code     : initLangCode,
                    temp_password : '',
                });
            }
        }
    }, [showModal, isEditMode, InitUserSeq, InitUser_id, InitUser_name, InitPhone_number, InitTel_number, InitEmail, initBranchCode, initAuthority, initStatus, initLangCode, selectedData]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [id]: value }));
    };

    const handleIdCheck = async (e) => {
        e.preventDefault();

        if (!formData.user_id) {
            alert(t(`COMMON.유효하지 않은 아이디 형식입니다.`, { defaultValue: '유효하지 않은 아이디 형식입니다.' }));
            return;
        };

        if (!isEmailValid(formData.user_id)) {
            alert('Please enter your ID in email format.');
            return;
        };
        
        try {
            const response = await API.checkUserId(formData.user_id);

            const message = response.result.content.message;

            // 정상 처리 시 1
            setIdCheckError(1);

            alert(t(`COMMON.${message}`, { defaultValue: message }));

        } catch (error) {
            if (error.response && error.response.status === 409) {
                // 409 Conflict에 대한 에러 메시지를 화면에 표시
                const message = error.response.data.result.content.message;

                // 중복시 9
                setIdCheckError(9);

                alert(t(`COMMON.${message}`, { defaultValue: message }));
            };

            return;
        };
    };

    // 이메일 정규표현식
    const isEmailValid = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    // 데이터 저장시에 useRef 를 통해서 
    const formRef = useRef(null);

    // 저장 함수
    const handleSave = async (e) => {
        e.preventDefault();

        if (!isEditMode && !formData.user_id) {
            alert(t(`COMMON.유효하지 않은 아이디 형식입니다.`, { defaultValue: '유효하지 않은 아이디 형식입니다.' }));
            return;
        };

        if (!isEmailValid(formData.user_id)) {
            alert('Please enter your ID in email format.');
            setIdCheckError(9);
            return;
        };

        if (!formData.user_name) {
            alert(t(`APPROVAL.직원명을 입력하세요`, { defaultValue: '직원명을 입력하세요' }));
            return;
        };
        
        if (!formData.phone_number) {
            alert(t(`COMMON.휴대폰 번호를 입력하세요.`, { defaultValue: '휴대폰 번호를 입력하세요.' }));
            return;
        };
        
        if (!formData.tel_number) {
            alert(t(`COMMON.전화번호를 입력하세요.`, { defaultValue: '전화번호를 입력하세요.' }));
            return;
        };
        
        if (!isEmailValid(formData.email)) {
            alert('email 형식이 잘 못 되었습니다.');
            return;
        };

        if (!isEditMode && !formData.temp_password) {
            alert('임시비밀번호를 입력하세요.');
            return;
        };

        if (!isEditMode && idCheckError !== 1) {
            alert(t(`COMMON.유효하지 않은 아이디 형식입니다.`, { defaultValue: '유효하지 않은 아이디 형식입니다.' }));
            return;
        };

        try {
            // 여기서 fetchSettings002DataPost를 호출하고 싶다면 아래와 같이 추가할 수 있습니다.
            const savedData = await API.fetchBase003DataPost({ formData });

            // 생성
            if (savedData.code === 201) {
                const message = savedData.result.content.message;

                setText(message);

                setToast(true);

                handleClose();

                return;
            };

            // 수정
            if (savedData.code === 200) {
                const message = savedData.result.content.message;

                setText(message);

                setToast(true);

                handleClose();

                return;
            }

        } catch (error) {
            const message = error.response.data.result.content.error;
            console.log(error.response.data.result.content.error); 
            alert(message);
        };
        
        try {
            // 수동으로 폼 제출
            formRef.current.submit();
        } catch (error) {
            console.error('수동으로 폼 제출 에러:', error);
            // 폼 제출이 실패했을 때 수행할 로직을 추가
        }
    };

    return (
        <>
            <CustomToast show={toast} setToast={setToast} text={text} />
            <Modal show={showModal} onHide={handleClose} centered dialogClassName="modal-lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t('STAFF_MANAGEMENT.직원등록', { defaultValue: '직원등록' })}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-start">
                    <div className="row gx-4">
                        <div className="col-lg-12">
                            <div className="card border-1 mb-4">
                                {/* 폼시작  2023.11.30 추가 전종표 */}
                                {/* ref={formRef}를 사용하여 formRef가 form 엘리먼트를 참조하도록 설정. 
                                그리고 handleSave 함수에서는 이 formRef를 사용하여 submit 메소드를 호출 */}
                                <form ref={formRef} onSubmit={handleSave}>
                                    <div className="card-body fw-bold">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group mb-0">
                                                    <div className="mb-3">
                                                        <label className="form-label" htmlFor="user_id">
                                                            {t('STAFF_MANAGEMENT.아이디', { defaultValue: '아이디' })} {isEditMode ? null : <span className="text-danger">*</span>}
                                                        </label>
                                                        {isEditMode 
                                                            ? <input className="form-control" type="email" id="user_id" value={formData.user_id} onChange={handleChange} readOnly={isEditMode} />
                                                            : <div className="position-relative">
                                                                <input className={`form-control ${
                                                                    idCheckError === 9 ? 'border-danger' : idCheckError === 1 ? 'border-success' : ''
                                                                }`} type="text" id="user_id" value={formData.user_id} onChange={handleChange} readOnly={isEditMode} />
                                                                <div className="input-group-prepend position-absolute top-0 end-0 bottom-0 d-flex">
                                                                    <button className="input-group-text btn btn-success" onClick={handleIdCheck}>
                                                                        <i className = "fa-solid fa-spell-check"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label" htmlFor="user_name">
                                                            {t('STAFF_MANAGEMENT.이름', { defaultValue: '이름' })} <span className="text-danger">*</span>
                                                        </label>
                                                        <input className="form-control" type="text" id="user_name" value={formData.user_name}  onChange={handleChange} />
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label" htmlFor="phone_number" >
                                                            {t('STAFF_MANAGEMENT.휴대폰번호', { defaultValue: '휴대폰번호' })} <span className="text-danger">*</span>
                                                        </label>
                                                        <input className="form-control" type="text" id="phone_number" value={formData.phone_number}  onChange={handleChange} />
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label" htmlFor="tel_number" >
                                                            {t('STAFF_MANAGEMENT.전화번호', { defaultValue: '전화번호' })} <span className="text-danger">*</span>
                                                        </label>
                                                        <input className="form-control" type="text" id="tel_number" value={formData.tel_number}  onChange={handleChange} />
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label" htmlFor="email">
                                                            {t('STAFF_MANAGEMENT.이메일주소', { defaultValue: '이메일주소' })} <span className="text-danger">*</span>
                                                        </label>
                                                        <input className="form-control" type="text" id="email" value={formData.email}  onChange={handleChange} />
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label" htmlFor="temp_password">
                                                            {t('STAFF_MANAGEMENT.임시비밀번호', { defaultValue: '임시비밀번호' })} {isEditMode ? null : <span className="text-danger">*</span>}
                                                        </label>
                                                        <input className="form-control" type="text" id="temp_password" value={formData.temp_password}  onChange={handleChange} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="form-group mb-0">
                                                    <div className="mb-3">
                                                        <label className="form-label" htmlFor="branch_code">{t('STAFF_MANAGEMENT.지점', { defaultValue: '지점' })}</label>
                                                        <select
                                                            className="form-select"
                                                            id="branch_code"
                                                            onChange={handleChange}
                                                            value={formData.branch_code}
                                                        >
                                                            {SelectOptions1.map((option, index) => (
                                                                <option key={index} value={option[0]}>
                                                                    {option[1]}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label" htmlFor="authority">{t('STAFF_MANAGEMENT.권한', { defaultValue: '권한' })}</label>
                                                        <select
                                                            className="form-select"
                                                            id="authority"
                                                            onChange={handleChange}
                                                            value={formData.authority}
                                                        >
                                                            {SelectOptions2.map((option, index) => (
                                                                <option key={index} value={option[0]}>
                                                                    {t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label" htmlFor="status">{t('STAFF_MANAGEMENT.상태', { defaultValue: '상태' })}</label>
                                                        <select
                                                            className="form-select"
                                                            id="status"
                                                            onChange={handleChange}
                                                            value={formData.status}
                                                        >
                                                            {SelectOptions3.map((option, index) => (
                                                                <option key={index} value={option[0]}>
                                                                    {t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label" htmlFor="lang_code">{t('ACCOUNT_INFO.다국어', { defaultValue: '다국어' })}</label>
                                                        <select
                                                            className="form-select"
                                                            id="lang_code"
                                                            onChange={handleChange}
                                                            value={formData.lang_code}
                                                        >
                                                            {SelectOptions4.map((option, index) => (
                                                                <option key={index} value={option[0]}>
                                                                    {t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })}
                                                                    {/* {option[0]} */}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                    {/* end Form */}

                                <div className="card-footer">
                                    <button className="btn btn-outline-success float-end mt-1 mb-1 me-1 ms-auto w-auto" onClick={handleSave}>{t('STAFF_MANAGEMENT.저장', { defaultValue: '저장' })} <i className="fa fa-sign-in"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="d-block">
                    <button className="btn btn-outline-gray me-1 mb-1 w-auto" onClick={handleClose}>
                        <i className="fa fa-backward"></i> {t('COMMON.이전', { defaultValue: '이전' })}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Base_003_01;